/**
 * DPO Collection Color Swatches
 *
 * Problem: Dawn's .card__heading a::after is position:absolute inset:0 z-index:1
 * covering the entire card. When you click a swatch, e.target is the <a> element,
 * not the swatch button — so closest('.dpo-color-swatch') returns null.
 *
 * Fix: use bounding-box hit detection. In the capture phase, check if the click
 * coordinates fall inside any swatch element on the page, regardless of e.target.
 */
(function () {

  var COLOR_MAP = {
    'white':        '#e8e8e8',
    'white gold':   '#e8e8e8',
    'silver':       '#c8c8c8',
    'yellow':       '#d4a843',
    'yellow gold':  '#d4a843',
    'gold':         '#d4a843',
    'rose':         '#e8a090',
    'rose gold':    '#e8a090',
    'pink':         '#f0b0a0',
    'platinum':     '#b8b8cc',
    'two tone':     'linear-gradient(135deg,#d4a843 50%,#e8e8e8 50%)',
    'yellow-white': 'linear-gradient(135deg,#d4a843 50%,#e8e8e8 50%)',
    'rose-white':   'linear-gradient(135deg,#e8a090 50%,#e8e8e8 50%)',
    'two-tone':     'linear-gradient(135deg,#d4a843 50%,#e8e8e8 50%)',
  };

  function getColorStyle(name) {
    var key = (name || '').toLowerCase().trim();
    if (COLOR_MAP[key]) return COLOR_MAP[key];
    for (var k in COLOR_MAP) {
      if (key.indexOf(k) !== -1 || k.indexOf(key) !== -1) return COLOR_MAP[k];
    }
    return '#ccc';
  }

  function applySwatchColors() {
    document.querySelectorAll('.dpo-color-swatch:not([data-dpo-colored])').forEach(function (btn) {
      btn.setAttribute('data-dpo-colored', '1');
      var imgUrl = btn.dataset.image;
      if (imgUrl) {
        btn.style.backgroundImage = "url(" + imgUrl + ")";
        btn.style.backgroundSize = "cover";
        btn.style.backgroundPosition = "center";
        btn.style.backgroundRepeat = "no-repeat";
      } else {
        var style = getColorStyle(btn.dataset.color || '');
        if (style.indexOf('gradient') !== -1) {
          btn.style.background = style;
        } else {
          btn.style.backgroundColor = style;
        }
      }
    });
  }

  // Find which swatch (if any) the click landed on, using bounding boxes.
  // This works even when e.target is the card's <a>::after overlay.
  function swatchAtPoint(x, y) {
    var swatches = document.querySelectorAll('.dpo-color-swatch');
    for (var i = 0; i < swatches.length; i++) {
      var r = swatches[i].getBoundingClientRect();
      if (x >= r.left && x <= r.right && y >= r.top && y <= r.bottom) {
        return swatches[i];
      }
    }
    return null;
  }

  document.addEventListener('click', function (e) {
    // Primary: direct target
    var btn = e.target && e.target.closest && e.target.closest('.dpo-color-swatch');

    // Fallback: bounding-box hit test (handles overlay link capturing the event)
    if (!btn) btn = swatchAtPoint(e.clientX, e.clientY);

    if (!btn) return;

    // Prevent card navigation
    e.preventDefault();
    e.stopImmediatePropagation();

    var imgUrl = btn.dataset.image;
    if (!imgUrl) return;

    var card = btn.closest('.card-wrapper');
    if (!card) return;

    // Update the main card image
    var mainImg = card.querySelector('.card__media img');
    if (mainImg) {
      mainImg.src = imgUrl;
      mainImg.srcset = '';   // clear srcset so browser uses src
      mainImg.sizes  = '';
    }

    // Update active ring
    var group = btn.closest('.dpo-card-swatches');
    if (group) {
      group.querySelectorAll('.dpo-color-swatch').forEach(function (s) {
        s.classList.remove('active');
      });
    }
    btn.classList.add('active');

  }, true); // capture phase — fires before the link's click handler

  function calculateWordMatchScore(alt, val) {
    if (!alt || !val) return 0;
    var altLc = alt.toLowerCase().trim();
    var valLc = val.toLowerCase().trim();
    var valDashed = valLc.replace(/\s+/g, '-');
    var valSpaced = valLc.replace(/-+/g, ' ');

    if (altLc.indexOf(valLc) !== -1 || altLc.indexOf(valDashed) !== -1 || altLc.indexOf(valSpaced) !== -1) {
      return 2.0;
    }

    var words = valLc.split(/[^a-z0-9]+/);
    var matchCount = 0;
    var significantWords = 0;
    for (var w = 0; w < words.length; w++) {
      var word = words[w];
      if (word.length >= 4) {
        significantWords++;
        if (altLc.indexOf(word) !== -1) {
          matchCount++;
        }
      }
    }

    if (significantWords > 0 && matchCount > 0) {
      return matchCount / significantWords;
    }
    return 0;
  }

  function appendQueryToUrl(url, searchParams) {
    if (!url) return url;
    try {
      var parsed = new URL(url, window.location.origin);
      searchParams.forEach(function (val, key) {
        parsed.searchParams.set(key, val);
      });
      var isAbsolute = url.indexOf('://') !== -1 || url.indexOf('//') === 0;
      if (isAbsolute) {
        return parsed.href;
      } else {
        return parsed.pathname + parsed.search + parsed.hash;
      }
    } catch (e) {
      console.warn('[DPO Swatches] Failed to append query to URL:', url, e);
      return url;
    }
  }

  function applyUrlQuerySelections() {
    var urlParams = new URLSearchParams(window.location.search);
    var hasParams = false;
    urlParams.forEach(function (val, key) {
      if (val) hasParams = true;
    });
    if (!hasParams) return;

    var allWrappers = document.querySelectorAll('.product-card, .card-wrapper, .product-card-wrapper');
    var mediaWrappers = document.querySelectorAll('.product-card[data-product-media], .card-wrapper[data-product-media], .product-card-wrapper[data-product-media]');
    console.log('[DPO Swatches] Query parameters found:', Array.from(urlParams.entries()));
    console.log('[DPO Swatches] Total card elements found:', allWrappers.length);
    console.log('[DPO Swatches] Total cards with media data found:', mediaWrappers.length);

    var targetCards = document.querySelectorAll('.product-card[data-product-media]:not([data-dpo-url-selected]), .card-wrapper[data-product-media]:not([data-dpo-url-selected]), .product-card-wrapper[data-product-media]:not([data-dpo-url-selected])');
    console.log('[DPO Swatches] Cards to process in this run:', targetCards.length);

    targetCards.forEach(function (card) {
      card.setAttribute('data-dpo-url-selected', '1');
      
      var rawMedia = card.getAttribute('data-product-media');
      if (!rawMedia) {
        console.log('[DPO Swatches] No data-product-media found on card:', card);
        return;
      }

      var mediaList = [];
      try {
        mediaList = JSON.parse(rawMedia);
      } catch (e) {
        console.error('[DPO Swatches] Failed to parse data-product-media JSON:', e, rawMedia);
        return;
      }
      if (!mediaList || mediaList.length === 0) return;

      var bestImg = null;
      var bestScore = 0;
      var bestAltLength = 9999;
      var cardTitle = card.querySelector('.product-title, .card__heading') ? card.querySelector('.product-title, .card__heading').textContent.trim() : 'Unnamed';

      console.groupCollapsed('[DPO Swatches Debug] Scoring images for:', cardTitle);

      for (var i = 0; i < mediaList.length; i++) {
        var alt = (mediaList[i].alt || '').toLowerCase();
        var score = 0;
        var matchReason = [];

        urlParams.forEach(function (val, key) {
          if (!val) return;
          var keyLc = key.toLowerCase().trim();

          var matchMultiplier = calculateWordMatchScore(alt, val);
          if (matchMultiplier > 0) {
            var baseScore = 1;
            if (keyLc === 'stone' || keyLc === 'gemstone' || keyLc === 'gem') {
              baseScore = 10;
            } else if (keyLc === 'color' || keyLc === 'colour' || keyLc === 'metal') {
              baseScore = 2;
            }
            var points = baseScore * matchMultiplier;
            score += points;
            matchReason.push(keyLc + '=' + val + ' (+' + points + ')');
          }
        });

        if (score > 0) {
          console.log('Image index:', i, 'alt:', alt, 'score:', score, 'reasons:', matchReason);
        }

        if (score > bestScore) {
          bestScore = score;
          bestImg = mediaList[i];
          bestAltLength = alt.length;
        } else if (score === bestScore && score > 0 && alt.length < bestAltLength) {
          bestImg = mediaList[i];
          bestAltLength = alt.length;
        }
      }

      console.log('Result for:', cardTitle, 'Best image match:', bestImg ? bestImg.src : 'None', 'Score:', bestScore);
      console.groupEnd();

      if (bestImg) {
        var mainImg = card.querySelector('.product-image-main, .card__media img');
        if (mainImg) {
          mainImg.src = bestImg.src;
          mainImg.srcset = '';
          mainImg.sizes = '';
        }
      }

      // Sync active swatch class
      var swatches = card.querySelectorAll('.product-swatches .swatch, .dpo-color-swatch');
      swatches.forEach(function (sw) {
        var swColor = (sw.getAttribute('title') || sw.getAttribute('data-color') || '').toLowerCase().trim();
        var isMatch = false;
        urlParams.forEach(function (val, key) {
          if (!val) return;
          var valLc = val.toLowerCase().trim();
          var valDashed = valLc.replace(/\s+/g, '-');
          var valSpaced = valLc.replace(/-+/g, ' ');

          if (swColor === valLc || swColor === valDashed || swColor === valSpaced ||
              valLc.indexOf(swColor) !== -1 || valDashed.indexOf(swColor) !== -1) {
            isMatch = true;
          }
        });

        if (isMatch) {
          swatches.forEach(function (s) { s.classList.remove('active'); });
          sw.classList.add('active');
        }
      });

      // Append query parameters to all product page links inside the card
      var links = card.querySelectorAll('a[href]');
      links.forEach(function (link) {
        var href = link.getAttribute('href');
        if (href && (href.indexOf('/products/') !== -1 || href.indexOf('/products?') !== -1)) {
          link.setAttribute('href', appendQueryToUrl(href, urlParams));
        }
      });
    });
  }

  // Collection-driven default: when card-product.liquid marks a swatch active
  // because the collection is metal-specific (e.g. "White Gold Rings"), sync the
  // card's main image to that swatch so the picture matches the selected metal.
  // Only runs on flagged cards; untouched on non-metal collections.
  function applyCollectionDefaults() {
    var groups = document.querySelectorAll('.dpo-card-swatches[data-dpo-collection-active]:not([data-dpo-default-done])');
    groups.forEach(function (group) {
      group.setAttribute('data-dpo-default-done', '1');
      var active = group.querySelector('.dpo-color-swatch.active');
      if (!active) return;
      var imgUrl = active.dataset.image;
      if (!imgUrl) return;
      var card = group.closest('.card-wrapper');
      if (!card) return;
      var mainImg = card.querySelector('.card__media img');
      if (mainImg) {
        mainImg.src = imgUrl;
        mainImg.srcset = '';
        mainImg.sizes = '';
      }
    });
  }

  function handleUpdates() {
    applySwatchColors();
    applyCollectionDefaults();
    applyUrlQuerySelections();
  }

  handleUpdates();
  document.addEventListener('shopify:section:load', handleUpdates);
  new MutationObserver(handleUpdates).observe(document.body, { childList: true, subtree: true });

})();
